'use client'

import { createContext, type PropsWithChildren, useContext } from 'react'

import type { DotEnv } from './dot-env.ts'

const Context = createContext<DotEnv | null>(null)

export const DotEnvProvider = ({ children, env }: PropsWithChildren<{ env: DotEnv }>) => {
  return <Context.Provider value={env} data-sentry-element="Context.Provider" data-sentry-component="DotEnvProvider" data-sentry-source-file="context.tsx">{children}</Context.Provider>
}

export const useDotEnv = (): DotEnv => {
  const context = useContext(Context)

  if (!context) {
    throw new Error('useDotEnv must be used within a DotEnvProvider')
  }

  return context
}
